import BottomSheet from "../components/BottomSheet.js";
import SettingsForm from "../components/SettingsForm.js";
import { postJSON } from "../helpers.js";

const RegisterDialog = (element, options = {}) => {
  const el = element;
  const opts = {
    ...options,
  };

  let settingsForm;

  const checkRegisterForm = () => {
    const payload = {
      email: settingsForm.validateEmail(settingsForm.form.email)?.trim(),
      name: settingsForm.form.name.value.trim(),
      accept_terms: !!settingsForm.form.accept_terms.checked,
      newsletter: !!settingsForm.form.newsletter.checked,
      service: settingsForm.form.service.value.trim(),
      id_token: settingsForm.form.id_token.value.trim(),
      picture: settingsForm.form.picture.value.trim(),
    };
    const registerButton = el?.querySelector("#register-button");
    if (payload.email && payload.email.length > 0 && payload.name.length > 0 && payload.accept_terms) {
      if (registerButton) registerButton.disabled = false;
      return payload;
    } else {
      if (registerButton) registerButton.disabled = true;
      return false;
    }
  };

  const handleRegisterFormSubmit = async (event) => {
    event.preventDefault();
    let formData = checkRegisterForm();
    if (formData) {
      formData.referer = window.location.href;
      const registerButton = el?.querySelector("#register-button");
      if (registerButton) registerButton.disabled = true;
      const data = await postJSON("/api/register/" + formData.service + "/", formData);
      if (registerButton) registerButton.disabled = false;
      if (data.status == "registered") {
        opts.onSuccessfulRegistration(data);
      } else {
        opts.onFailedRegistration(data);
      }
    }
  };

  const component = BottomSheet(el, {
    componentName: "RegisterDialog",
    closeOnBackdropClick: false,
    scrollBody: true,
    onOpen: async (user, title, action) => {
      settingsForm = SettingsForm(el.querySelector("#register-settings-form"), {
        onSubmit: (event, submitButton) => handleRegisterFormSubmit(event, submitButton),
      }).mount();

      settingsForm.on("email", "input blur", () => {
        checkRegisterForm();
      });
      settingsForm.on("name", "input blur", () => {
        checkRegisterForm();
      });
      settingsForm.on("accept_terms", "change", () => {
        checkRegisterForm();
      });

      settingsForm.setValue("email", user.email || "");
      settingsForm.setValue("name", user.name || "");
      settingsForm.setValue("service", user.service || "email");
      /* cleanup */
      let existingSocialButton = el.querySelector("#register-settings-form button.social-sign-in-button");
      if (existingSocialButton) existingSocialButton.parentElement.removeChild(existingSocialButton);
      settingsForm.setCheckbox("accept_terms", false);
      settingsForm.setCheckbox("newsletter", false);

      settingsForm.enable();

      if (user.service && user.service !== "email") {
        const socialButton = document.createElement("button");
        socialButton.type = "button";
        socialButton.className = "button social-sign-in-button";
        if (user.service == "google") {
          socialButton.className += " google-color";
          socialButton.innerHTML = '<i class="google-logo"></i><span>' + user.name + " (Google)</span>";
        }
        if (user.service == "facebook") {
          socialButton.className += " facebook-color";
          socialButton.innerHTML = '<i class="fab fa-facebook"></i><span>' + user.name + " (Facebook)</span>";
        }
        settingsForm.form.insertBefore(socialButton, settingsForm.form.service);
      }

      settingsForm.setValue("id_token", user.id_token || "");
      settingsForm.setValue("picture", user.picture || "");
      // TODO: display picture, or not...

      if (el) {
        el.querySelector(".bottom-sheet-header strong").innerHTML =
          title || el.querySelector(".bottom-sheet-header strong").dataset.default;
        el.querySelector("#register-button .active span").innerHTML =
          action || el.querySelector("#register-button .active span").dataset.default;
        el.querySelector("#register-button .disabled span").innerHTML =
          action || el.querySelector("#register-button .disabled span").dataset.default;
      }

      checkRegisterForm();
    },
    onClose: async () => {
      if (settingsForm) {
        settingsForm.unmount();
      }
    },
  });

  return component;
};

export default RegisterDialog;
